import List from './List';
import Show from './Show';
import './reports.css';

export default {
    list: List,
    show: Show,
};
